import axios from 'axios'
import { baseURL } from '@/request'
import { toLogin } from './toLogin'
import { suiteId } from '../config'
import { repeatedlyPromiseInterceptor } from '../../../utils'

// token, 如果自由token系统，则应该导入当前登录系统下的token处理模块
import { setToken, removeToken, getFeishuAuthCode, removeFeishuAuthCode } from '../../../core'
export * from '../../../core/token'
export * from '../../../core/workWechat/workWechatAuthToken'

/**
 * 获取登录后的token
 */
export function fetchTokenByFeishuWeb(data) {
  return axios({
    baseURL,
    url: '/feishu/login/web',
    method: 'POST',
    data
  })
}

/**
 * 尝试通过企业微信auth_code登录
 */
export const _fetchTokenFn = async (isErrorExport = false) => {
  console.log('feishu fetchToken')
  removeToken()
  // 校验authCode是否存在
  const authCode = getFeishuAuthCode()
  if (!authCode) {
    toLogin()
    return Promise.reject('[feishu web no code]权限校验错误，忽略本次跳转')
  }
  // 删除已经拿到的token
  removeFeishuAuthCode()
  // 请求交换code
  try {
    const res = await fetchTokenByFeishuWeb({ authCode })
    console.log('fetch token success', res)
    if (!res?.data?.data) { throw new Error('empty token') }
    setToken(res.data.data)
    return Promise.resolve(res.data.data)
  } catch (e) {
    console.error('fetch token error: ', e)
    // === 外部处理 ==
    if (isErrorExport) { return Promise.reject(e) }
    // 内部直接跳转
    toLogin()
    // 返回错误不进行跳转
    return Promise.reject('[feishu web reject]权限校验错误，忽略本次跳转')
  }
}

export const fetchToken = repeatedlyPromiseInterceptor((interceptor) => {
  _fetchTokenFn(false).then(interceptor.resolve).catch(interceptor.reject)
})